/** GraphQL documents. Kept as plain strings so no codegen step is required. */

const USER_FIELDS = `screenName presence awayMessage profileText lastSeen createdAt`;
const BUDDY_FIELDS = `screenName group presence awayMessage lastSeen`;
const MESSAGE_FIELDS = `id convoId from to body sentAt`;
const PRESENCE_FIELDS = `screenName presence awayMessage lastSeen`;

export const Q_ME = `query Me { me { ${USER_FIELDS} } }`;

export const Q_GET_USER = `query GetUser($screenName: ID!) {
  getUser(screenName: $screenName) { ${USER_FIELDS} }
}`;

export const Q_BUDDY_LIST = `query BuddyList { buddyList { buddies { ${BUDDY_FIELDS} } } }`;

export const Q_CONVERSATION = `query Conversation($with: ID!, $limit: Int, $nextToken: String) {
  conversation(with: $with, limit: $limit, nextToken: $nextToken) {
    items { ${MESSAGE_FIELDS} }
    nextToken
  }
}`;

export const M_SEND_MESSAGE = `mutation SendMessage($to: ID!, $body: String!) {
  sendMessage(to: $to, body: $body) { ${MESSAGE_FIELDS} }
}`;

export const M_SET_PRESENCE = `mutation SetPresence($presence: Presence!, $awayMessage: String) {
  setPresence(presence: $presence, awayMessage: $awayMessage) { ${PRESENCE_FIELDS} }
}`;

export const M_SET_TYPING = `mutation SetTyping($to: ID!, $state: TypingState!) {
  setTyping(to: $to, state: $state) { from to state }
}`;

export const M_BUZZ = `mutation Buzz($to: ID!) { buzz(to: $to) { from to at } }`;

export const M_ADD_BUDDY = `mutation AddBuddy($screenName: ID!, $group: String) {
  addBuddy(screenName: $screenName, group: $group) { ${BUDDY_FIELDS} }
}`;

export const M_REMOVE_BUDDY = `mutation RemoveBuddy($screenName: ID!) { removeBuddy(screenName: $screenName) }`;

export const M_UPDATE_PROFILE = `mutation UpdateProfile($profileText: String!) {
  updateProfile(profileText: $profileText) { ${USER_FIELDS} }
}`;

export const S_ON_MESSAGE = `subscription OnMessage($to: ID!) {
  onMessage(to: $to) { ${MESSAGE_FIELDS} }
}`;

export const S_ON_PRESENCE = `subscription OnPresence($screenName: ID!) {
  onPresence(screenName: $screenName) { ${PRESENCE_FIELDS} }
}`;

export const S_ON_TYPING = `subscription OnTyping($to: ID!) {
  onTyping(to: $to) { from to state }
}`;

export const S_ON_BUZZ = `subscription OnBuzz($to: ID!) { onBuzz(to: $to) { from to at } }`;
